var map = {
	"./azienda_bg.png": "./app/javascript/assets/images/leanbit_home/azienda_bg.png",
	"./nosco_interfaccia_home.png": "./app/javascript/assets/images/leanbit_home/nosco_interfaccia_home.png",
	"./nosco_interfaccia_home_2.png": "./app/javascript/assets/images/leanbit_home/nosco_interfaccia_home_2.png",
	"./nosco_ragazza_interfaccia.png": "./app/javascript/assets/images/leanbit_home/nosco_ragazza_interfaccia.png",
	"./nosco_slider.png": "./app/javascript/assets/images/leanbit_home/nosco_slider.png",
	"./nuvola_cloud.svg": "./app/javascript/assets/images/leanbit_home/nuvola_cloud.svg",
	"./soluzioni_cloud_pagina.png": "./app/javascript/assets/images/leanbit_home/soluzioni_cloud_pagina.png",
	"./soluzioni_cloud_slider.png": "./app/javascript/assets/images/leanbit_home/soluzioni_cloud_slider.png",
	"./soluzioni_personalizzate_img.png": "./app/javascript/assets/images/leanbit_home/soluzioni_personalizzate_img.png",
	"./soluzioni_personalizzate_pagina.png": "./app/javascript/assets/images/leanbit_home/soluzioni_personalizzate_pagina.png",
	"./soluzioni_personalizzate_slider.png": "./app/javascript/assets/images/leanbit_home/soluzioni_personalizzate_slider.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/leanbit_home sync recursive \\.(png|jpe?g|svg)$";